import { init as initFMS } from '@storebrand-digital/fms-translations';
import { initFooter, initNavbar } from '@/utils/micros';

import App from '@/app/index';
import React from 'react';
import { Version } from '@storebrand-digital/fms-translations/dist/types';
import { createRoot } from 'react-dom/client';
// eslint-disable-next-line import/no-unresolved
import en from '@/fms-fallbacks/fallback-en.json';
// eslint-disable-next-line import/no-unresolved
import no from '@/fms-fallbacks/fallback-no.json';
import packageJson from '../package.json';

async function bootstrap() {
  initNavbar();
  initFooter();
  await initFMS({
    clientId: packageJson.name,
    documentIds: ['errorPagesWeb'],
    fallback: { no, en },
    version: window.env.TRANSLATION_VERSION as Version,
  });

  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  }
}

export default bootstrap;
